import React, { useState } from "react";
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import WhySection from "../components/UI/WhySection";
import { Container, Row, Col } from "reactstrap";
import EarnWithUs from "../components/UI/EarnWithUs";
import Statistics from "../components/UI/Statistics";
import "../styles/about.css";
import carRental from "../assets/all-images/cars-img/CarRental.gif";

const About = () => {
  const faqData = [
    {
      question: "What is your company's mission?",
      answer:
        "To be the best car rental service in Kenya and beyond.",
    },
    {
      question: "How long has your company been in operation?",
      answer: "We have launched our company in the year 2023.",
    },
    {
      question: "Where are your offices located?",
      answer: "Our offices are currently located in Nairobi ,Kenya.",
    },
    // Add more FAQ items here
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <Helmet title="About">
      <CommonSection title="FAQ" />
      <WhySection aboutClass="whyPage" />

      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <div className="about__page-img">
              <img src={carRental} alt="" className="w-100 rounded-3" />
              </div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <div className="about__page-content">
                <div className="mt-5">
                  <h2 className="section__title">Frequently Asked Questions</h2>
                  {faqData.map((item, index) => (
                    <div key={index} className="mb-4">
                      <div
                        className="flex justify-between items-center bg-gray-100 p-4 rounded cursor-pointer"
                        onClick={() => toggleAccordion(index)}
                      >
                        <h3 className="text-lg font-bold">{item.question}</h3>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 ${
                            activeIndex === index ? "transform rotate-180" : ""
                          }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      {activeIndex === index && (
                        <div className="bg-gray-200 p-4 rounded mt-2">
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <p className="section__description">
                  {/* ... (description code) */}
                </p>

               
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <EarnWithUs />

      <section>
        <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              
              <h2 className="text-3xl font-bold text-center mb-2 mt-6">Statistics and Achievements</h2>
            </Col>
            <Statistics />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;
